// BOORO: how a message from a task's sub-chat reaches the agent.

/** A working run, one waiting for an answer, or none: the message waits on the task. */
export type TaskMessageRoute = "steer" | "answer" | "queue";

const BUSY_RUN_STATUSES = new Set(["queued", "leased", "running"]);
const QUEUED_TASK_STATUSES = new Set(["todo", "doing"]);

/**
 * A working agent reads the message at its next step, a waiting one takes it as the
 * answer. Otherwise it waits on the task as a comment and the task goes back to work.
 */
export function taskMessageRoute(latestRunStatus: string | null | undefined): TaskMessageRoute {
  if (latestRunStatus && BUSY_RUN_STATUSES.has(latestRunStatus)) return "steer";
  if (latestRunStatus === "waiting_input") return "answer";
  return "queue";
}

/** A task that is done, dropped, stopped or blocked goes back into the queue when written to. */
export function taskReopensOnMessage(ticketStatus: string): boolean {
  return !QUEUED_TASK_STATUSES.has(ticketStatus);
}

/** The one action a task's sub-chat offers beside its title. */
export type TaskPanelAction = "stop" | "resume" | "review" | null;

const OPEN_RUN_STATUSES = new Set([...BUSY_RUN_STATUSES, "waiting_input", "waiting_takeover"]);

/**
 * An agent on the task can be stopped. A stopped or stuck task can be resumed, and a
 * finished one waits for approval.
 */
export function taskPanelAction(
  ticketStatus: string,
  latestRunStatus: string | null | undefined,
): TaskPanelAction {
  if (latestRunStatus && OPEN_RUN_STATUSES.has(latestRunStatus)) return "stop";
  if (ticketStatus === "blocked") return "resume";
  if (ticketStatus === "review") return latestRunStatus === "cancelled" ? "resume" : "review";
  return null;
}
